import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './Navbar.css';

function Navbar() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/dashboard" className="navbar-logo">
          🎁 Loyalty Rewards
        </Link>
        
        <div className="navbar-menu">
          <Link to="/dashboard" className="navbar-link">Dashboard</Link>
          <Link to="/rewards" className="navbar-link">Rewards</Link>
          <Link to="/membership" className="navbar-link">🛸 Card</Link>
          <Link to="/tiers" className="navbar-link">VIP Tiers</Link>
          <Link to="/history" className="navbar-link">History</Link>
          {user?.role === 'admin' && (
            <Link to="/admin" className="navbar-link admin-link">Admin</Link>
          )}
        </div>

        <div className="navbar-user">
          <span className="user-name">{user?.name}</span>
          <span className="user-points">{user?.points || 0} pts</span>
          <button onClick={handleLogout} className="btn-logout">Logout</button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
